import { render, staticRenderFns } from "./DocumentMaterialComments.vue?vue&type=template&id=ab187ab8"
import script from "./DocumentMaterialComments.vue?vue&type=script&lang=js"
export * from "./DocumentMaterialComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports